// https://atomiks.github.io/tippyjs/
// https://codepen.io/anon/pen/mzGjzw?editors=0110

import tippy from 'tippy.js';
import Base from './base';

class Dropdown extends Base {
	start() {
		this.button = this.el.querySelector('[aria-controls]');
		this.menu = this.el.querySelector('[role=menu]');

		const placement = this.options.placement || 'bottom';

		tippy(this.button, {
			content: this.menu,
			interactive: true,
			trigger: 'click',

			interactiveBorder: 10,
			interactiveDebounce: 0,

			placement,

			// open, hide time
			delay: [0, 0],

			// transition in, transition out time
			duration: [0, 0],
		});
	}
}

export default Dropdown;
